export default __webpack_public_path__ + "static/media/payment-slip.f6e4e061.svg";